export enum JobTypeEnum{
  Undefined = 0,
  Import = 1,
  Export = 2,
  DomesticInbound = 3,
  DomesticOutbound = 4,
  RailInbound = 5,
  RailOutbound = 6,
  IntermodalCoastal = 7,
  IntermodalRail = 8,
  MoveMt = 9,
  MoveFull = 10,
  OnSite = 11
}
